function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrev = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "-293 384 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m-278.506 405.379 3.33-3.33-5.55-5.55 5.55-5.55-3.33-3.33-8.879 8.879z",
    style: {
      fill: "#000"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrev);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/prev.svg";